import React, { Component } from 'react';
import styles from './index.css';
import FontAwesome from 'react-fontawesome';
import logo from "./logo.png";
import {observer} from 'mobx-react';
import {score} from '../../stores/index'
import {Link} from 'react-router-dom';

@observer
export default class Menu extends Component {
    render(){
        const color = {backgroundColor:`rgb(${score.menu <=60 ? 251 : 251 - (score.menu.toFixed(1)-60)*3.5 },${score.menu <=60 ? score.menu.toFixed(1)*3.5 : 210},${19})`};
        return(
            <div className={styles.item + ' ' + styles.title}>
                <div>
                    <Link to="/" className={styles.burger}>&#9776;</Link>
                    <div className={styles.companyLogo}><img src={logo} alt="Company_logo"/></div>
                </div>
                <div className={styles.elevatorName}>{score.elevatorsName}</div>
                <div className={styles.costContainer}>
                    <div className={styles.cost}>${score.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</div>
                    <div className={styles.score + ' ' + styles.scoreDropDownTrigger} style={color}>
                        <FontAwesome name={score.menu <=50 ? 'frown-o' : 'smile-o'} />
                        &nbsp;{Math.floor(score.menu)}&nbsp;
                        <FontAwesome name='info-circle' />
                        <div className={styles.scoreDropDown}>
                          <h3>Рейтинг элеваториста</h3>
                          <p>Этот индикатор показывает насколько ваши контрагенты довольны работой с&nbsp;вами.</p>
                          <p>Если вы&nbsp;нарушаете условия, заставляете долго ждать контрагентов на&nbsp;приёмке и&nbsp;на&nbsp;отгрузке или если у&nbsp;вас долго простаивают мощности элеватора из-за неправильных настроек&nbsp;&mdash; ваш рейтинг будет снижаться, а&nbsp;индикатор становиться всё более красным, это будет влиять на&nbsp;то, насколько ваши контрагенты будут выполнять свои обязательства и&nbsp;следовать планам приёмки и&nbsp;отгрузки.</p>
                          <p>И&nbsp;наоборот, если вы&nbsp;всё делаете в&nbsp;срок и&nbsp;ваш элеватор работает как часы&nbsp;&mdash; ваш рейтинг будет расти, индикатор становиться зеленым, а&nbsp;контрагенты будут строго придерживаться графика поставок, что позволит вам точнее планировать ваши активности.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Menu/index.js